import type { FC } from 'react';
import React, { useEffect } from 'react';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import { get as getCookie } from 'js-cookie';

import { sendAmplitudeEvent } from '../../helpers/api/amplitude-api';
import { useFormContext } from '../../components/form/context';
import { LK_HOST } from '../../config';

import type { TSuccessWithRedirect } from './models';

export const SuccessWithRedirect: FC<TSuccessWithRedirect> = ({
    Spinner,
    Text,
    isMobile,
    styles,
}) => {
    const { formId, redirectInfo } = useFormContext();
    const { draftUid, redirectPathTemplate, uid } = redirectInfo;

    useEffect(() => {
        sendEvent({
            event: 'site_formRequest_welcomePage',
            formId,
            url: window.location.href,
            title: document.title,
        });

        sendAmplitudeEvent({
            deviceId: getCookie('_ym_uid') as string,
            eventType: 'site_formRequest_welcomePage',
            userId: getCookie('alfaleasing-user-id'),
            eventProperties: {
                formId,
                url: window.location.href,
                title: document.title,
            },
        });
    }, [formId]);

    useEffect(() => {
        setTimeout(() => {
            sendEvent({
                event: 'site_formRequest_welcomePage_button',
                formId,
                name: 'Войти в личный кабинет',
                url: window.location.href,
                title: document.title,
            });

            sendAmplitudeEvent({
                deviceId: getCookie('_ym_uid') as string,
                eventType: 'site_formRequest_welcomePage_button',
                userId: getCookie('alfaleasing-user-id'),
                eventProperties: {
                    formId,
                    url: window.location.href,
                    title: document.title,
                    name: 'Войти в личный кабинет',
                },
            });

            // uid не будет в ответе step-by-step, если status="ACCESS_TO_LK"
            const idStr = uid ? `id=${String(uid)}&` : '';
            const path = redirectPathTemplate?.replace(
                /id={[^&]+}/,
                `${idStr}draftId=${String(draftUid)}`
            );

            window.location.href = `${LK_HOST}${path}`;
        }, 2000);
    }, [draftUid, formId, redirectPathTemplate, uid]);

    return isMobile ? (
        <div className={styles.rootMobile}>
            <div className={styles.descriptionMobile}>
                <div>
                    <Text fontSize={20} fontWeight={5} lineHeight={28} tag="div">
                        Получите персональный расчёт
                    </Text>
                    <Text fontSize={20} fontWeight={5} lineHeight={28} tag="div">
                        в личном кабинете за 1,5
                    </Text>
                    <Text fontSize={20} fontWeight={5} lineHeight={28} tag="div">
                        минуты
                    </Text>
                </div>
            </div>
            <Spinner className={styles.spinner} size="7xl" />
            <Text fontSize={16} fontWeight={4} lineHeight={24} tag="div">
                Переходим в личный кабинет...
            </Text>
            <div className={styles.subtextMobile}>
                <Text tag="div" view="secondary-medium">
                    Если у вас сейчас нет времени на получение
                </Text>
                <Text tag="div" view="secondary-medium">
                    персонального расчёта, свяжемся с вами в течение
                </Text>
                <Text tag="div" view="secondary-medium">
                    3 часов
                </Text>
            </div>
        </div>
    ) : (
        <div className={styles.root}>
            <div className={styles.titleWrapper}>
                <Text fontSize={22} fontWeight={7} lineHeight={26} tag="div">
                    Получите персональный расчёт в личном
                </Text>
                <Text fontSize={22} fontWeight={7} lineHeight={26} tag="div">
                    кабинете за 1,5 минуты
                </Text>
            </div>
            <Spinner className={styles.spinner} size="7xl" />
            <Text fontSize={16} fontWeight={4} lineHeight={24} tag="div">
                Переходим в личный кабинет...
            </Text>
            <div className={styles.description}>
                <Text tag="div" view="secondary-medium">
                    Если у вас сейчас нет времени на получение персонального расчёта, свяжемся
                </Text>
                <Text tag="div" view="secondary-medium">
                    с вами в течение 3 часов
                </Text>
            </div>
        </div>
    );
};
